module.exports = __webpack_public_path__ + "error-bg.5df682a513bde1494964.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/images/background/error-bg.jpg
// module id = ../../../../../theme/images/background/error-bg.jpg
// module chunks = styles